import React, { useState } from "react";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../../sanitize-html.whitelist";
import { CheckBoxProps } from "./CheckBox.types";
import { Input, Container, Label, ErrorMessage } from "./CheckBox.style";

export default function CheckBox({
  id,
  text,
  isRequired,
  requiredLabel,
  onChange,
}: CheckBoxProps) {
  const [checked, setChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    if (isRequired) {
      setShowError(!isChecked);
    }
    onChange(isChecked);
  };

  return (
    <div>
      <Container>
        <Input
          type="checkbox"
          id={id}
          required={isRequired}
          onChange={handleChange}
          checked={checked}
        />
        <Label
          htmlFor={id}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(text, sanitizeWhiteList),
          }}
        />
      </Container>
      {isRequired && showError && <ErrorMessage>{requiredLabel}</ErrorMessage>}
    </div>
  );
}
